import { memo, useMemo, CSSProperties } from 'react';
import { ContractColumnRow } from './ContractColumnRow';
import { ColumnRowProps } from '../../ColumnRowProps';
import { ROW_HEIGHT, BORDER, COLUMN_WIDTH } from '../../../../CONSTANTS';
import { useGridRowContext } from '../../../../../../../_grid/contexts/rowContext';

export const ContractColumnContainer = memo(function ContractColumnContainer({ columnIndex, columnRow, rowId, start }: ColumnRowProps & { start: number }) {
    const { toggleExpanded } = useGridRowContext();
    const style = useMemo(() => {
        return {
            width: `${COLUMN_WIDTH}px`,
            position: 'absolute',
            transform: `translateX(${start}px)`,
            top: 0,
            left: 0,
            height: `${ROW_HEIGHT}px`,
            boxSizing: 'border-box',
            borderBottom: BORDER,
            borderRight: BORDER,
            display: 'flex',
            justifyContent: 'center',
        } as CSSProperties;
    }, [start]);
    return (
        <div style={style} onClick={() => toggleExpanded()}>
            <ContractColumnRow columnRow={columnRow} columnIndex={columnIndex} rowId={rowId} />
        </div>
    );
});
